import { Link } from '@remix-run/react'
import { FC } from 'react'
import { trackEvent } from '~/utils/tracking'

type MobileNavLinkProps = {
  title: string
  link: string
  isAuthRequired?: boolean
  closeMenu: () => void
}

const MobileNavLink: FC<MobileNavLinkProps> = ({
  link,
  title,
  isAuthRequired = false,
  closeMenu,
}) => {
  const handleClick = () => {
    trackEvent('click_website_menu', { click_menu_category: title as string })
    closeMenu()
  }

  return (
    <Link className="block" to={isAuthRequired ? '/app/auth/sign-in' : link} onClick={handleClick}>
      <div className="ml-0">
        <div className="cursor-pointer border-b border-neutral-10 flex items-center justify-between py-5 px-0 text-mobile-s">
          {title}
        </div>
      </div>
    </Link>
  )
}

export default MobileNavLink
